module.exports = __webpack_public_path__ + "img/catch_covid.f920c61c.svg";